export default [
    {
        path: 'ad/list',
        name: 'content_ad_list',
        meta: { isCache: true, icon: 'md-pin', hideInMenu: false },
        component: () => import('@/views/content/ad/ad-list.vue'),
    },
    {
        path: 'ad/add',
        name: 'content_ad_add',
        meta: { isCache: false, icon: 'md-add', hideInMenu: true },
        component: () => import('@/views/content/ad/ad-add.vue'),
    },
    {
        path: 'ad/edit/:id',
        name: 'content_ad_edit',
        meta: { isCache: false, icon: 'md-create', hideInMenu: true },
        component: () => import('@/views/content/ad/ad-edit.vue'),
    },
    {
        path: 'ad/detail/:id',
        name: 'content_ad_detail',
        meta: { isCache: false, icon: 'md-list-box', hideInMenu: true },
        component: () => import('@/views/content/ad/ad-detail.vue'),
    },
];
